import ProjectRoute from "./ProjectRoute";

export default ProjectRoute;


// WEBPACK FOOTER //
// ./src/js/project-v2/index.js